module.exports = __webpack_public_path__ + "img/search.7da37f36.svg";